// extracted by mini-css-extract-plugin
export default {"mainContent":"ServiceOfferingsPage_mainContent__tCPg+"};